import React, { Component } from "react";
import clsx from 'clsx';
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import Delete from '../../../../assets/img/svg/delete.svg'
import { Tabs, Tab, AppBar, Typography, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import EditSOC_Detail from './EditSOC-Detail'
import EditSOC_Historylog from './EditSOC-Historylog'
import del from "../../../../assets/img/svg/Del.svg"
import { useNavigate } from "react-router-dom"
import download from "../../../../assets/img/svg/DownloadIcon.svg"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
//mport PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import $ from "jquery"
import { } from "../../../../actions/SOCAction";
import axios from "axios";
import API from "../../../../_helpers/endpointService";
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: "none !important"
    },
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
    indicator: {
        backgroundColor: "#00838F",
    },
}));

// const EditSOC = () => {
//     const classes = useStyles();
//     const [value, setValue] = React.useState(0);
//     const navigate = useNavigate();

//     useEffect(() => {

//     }, []);

class EditSOC extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            isView: false,
            isMobile: false,
            addData: {
                Id: 0,
                ProjectId: 0,
                Date: '',
                DocumentName: "",
                Comments: "",
                DocumentId: 0,
            },
            Error: {
                "DateError": false,
            },
        }
    }
    componentDidMount() {
        const { dispatch } = this.props;
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.addData.DocumentId = parseInt(localStorage.getItem("SOCEditId"))
        this.state.addData.Id = parseInt(localStorage.getItem("SOCEditId"))
        let tempdata = {
            data: parseInt(localStorage.getItem("SOCEditId"))
        }
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        this.props.dispatch({ type: "ERROR_SOCFILES", data: this.state.Error })
        //window.location.pathname == '/prebeachingdocuments/edit' ? this.setState({isView:false}) : this.setState({isView:false})
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
        $("#Statement1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Statement").addClass("d-none");
        $("#Statement").removeClass("d-block");
        $("#SOCL").removeClass("active-color");
        $("#SOCT").removeClass("fw-bolder");
    }
    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
        })
    };
    sidebar = () => {
        this.props.navigate("/sidebar");
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#Statement1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Statement").removeClass("d-none");
        $("#Statement").addClass("d-block");
        $("#SOCL").addClass("active-color");
        $("#SOCT").addClass("fw-bolder");
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.addData = this.props.sharedsocdata;
        this.setState({})

    };
    EditCancel = () => {
        let tempData = {
            Id: 0,
            ProjectId: 0,
            Date: '',
            DocumentName: "",
            Comments: ""
        }
        this.props.dispatch({ type: "SHARE_SOCDATAS", data: tempData })
        this.props.dispatch({ type: "SHARE_SOCFILES", data: {} })
        this.props.navigate("/statementofcompletion")
    };
    EditSave = () => {

        if (this.props.sharedsocdata.Date == "") {
            this.state.Error.DateError = true;
            this.setState({})
            this.props.dispatch({ type: "ERROR_SOCDATAS", data: this.state.Error })
        }
        else {
            this.state.Error.DateError = false;
            this.setState({})
        }
        if (this.props.sharedsocdata.Date !== '') {
            let formData = new FormData()
            let array = [];
          
            if (this.props.sharedsocfiles.fdata != '') {
                formData.append("Attachments", this.props.sharedsocfiles.fdata)
            }
            this.putsocdocinfo(this.props.sharedsocdata, formData, this.state.addData.ProjectId)
        }
        else {
            this.props.dispatch({ type: "ERROR_SOCDATAS", data: this.state.Error })
        }
    }
    putsocdocinfo = (data, formData, id) => {

        let apiUrl = API.STATEMENTOFCOMPLETION + '/id?projectId=' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    if (this.props.sharedsocfiles.fdata != undefined) {
                        this.adduploadsocdocinfo(formData, data.DocumentId)
                    }
                    else {
                        this.props.navigate("/statementofcompletion")
                    }

                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });
    };
    adduploadsocdocinfo = (data, id) => {
        let PId = parseInt(localStorage.getItem("DashId"));
        let apiUrl = API.STATEMENTOFCOMPLETION + '/' + id + '?projectId=' + PId;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/statementofcompletion")
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };

    DeleteItem = () => {

    }
    render() {
        let { classes, menuToggle } = this.props;

        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"Statement" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="Statement" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5 ">
                                    <h4>Statement of Completion</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ? <table className="dataTable border-top" width="100%">
                        <tbody>
                            <tr>
                                <td className="border-right text-center">
                                    <i class="fa fa-arrow-left cursorPointer" onClick={this.EditCancel}></i></td>
                                <td className="border-right text-center">
                                    <button className={classes.button} onClick={this.EditSave}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                </td>
                                <td className="border-right text-center">
                                    <button className={`${classes.button} `} onClick={this.EditCancel}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                        : <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.EditCancel}></i></td>
                                    <td width="95%">

                                        <button className={classes.button} onClick={this.EditSave} style={{ minWidth: '70px' }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                        <button className={`${classes.button} `} onClick={this.EditCancel} style={{ minWidth: '70px' }}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>}
                    <div style={{ margin: this.state.isMobile ? "0" : "15px 45px" }}>
                        {this.state.isMobile ? <></> : <h6 className="col-12 ml-2">Statement of Completion</h6>}
                        <div className="row mt-4">
                            <div >
                                <AppBar position="static" color="inherit" className={classes.root}>
                                    <Tabs
                                        value={this.state.value}
                                        onChange={this.handleChange}
                                        classes={{ indicator: classes.indicator }}
                                    >
                                        <Tab label="Details" {...a11yProps(0)} />
                                        <Tab label="History log" {...a11yProps(1)} />
                                    </Tabs>
                                </AppBar>
                                <TabPanel value={this.state.value} index={0}>
                                    <EditSOC_Detail />
                                </TabPanel>
                                <TabPanel value={this.state.value} index={1}>
                                    <EditSOC_Historylog />
                                </TabPanel>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>

                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>

                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5>  </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItem}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        errorsocpass: state.SOCReducer.errorsocpass || [],
        sharedsocfiles: state.SOCReducer.sharedsocfiles || [],
        sharedsocdata: state.SOCReducer.sharedsocdata || [],
    };
}

EditSOC.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditSOC))
);

